import { AlertTriangle, BookOpen } from "lucide-react";
import React from "react";
import { Modal, notification, Select } from "antd";
import { unAssignMockInterviewToCandidate } from "../../../../../../api/org-admin";
import WebUtils from "../../../../../../utils/WebUtils";
import Utils from "../../../../../../utils/Utils";

function UnassignStudentModal({
  unAssignStudentFlag,
  setUnAssignStudentFlag,
  setLoading,
  selectedUserIds,
  refreshApis,
}) {
  const jobGuideId = window.location.pathname.split("/").pop();
  const userDetail = Utils.getUserDetail();
  const searchParams = new URLSearchParams(window.location.search);
  const iDronaId = searchParams.get("iDronaId");

  const handleSubmit = () => {
    const url = `${unAssignMockInterviewToCandidate}?userIdentifier=${userDetail.userIdentifier}&iDronaInterviewConfigurationId=${iDronaId}&organizationId=${userDetail.organizationId}
`;
    setLoading(true);
    const body = {
      candidateIds: selectedUserIds,
      jodGuideIds: [jobGuideId],
      organizationId: userDetail?.organizationId,
      userIdentifier: userDetail?.userIdentifier,
    };

    WebUtils.httpOperations(url, selectedUserIds, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          notification.success({
            message: "Success",
            description: `${"Guide unassigned from student(s)!"}`,
            placement: "topRight",
            showProgress: true,
            duration: 3,
          });
          refreshApis();
          setUnAssignStudentFlag(false);
        } else {
          notification.error({
            message: "Failed",
            description: `${result?.data?.resultStatusInfo?.message}`,
            placement: "topRight",
            // showProgress: true,
            duration: 3,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  return (
    <Modal
      open={unAssignStudentFlag}
      onCancel={() => setUnAssignStudentFlag(false)}
      footer={null}
      centered
      width={540}
      title={
        <div className="flex items-center gap-3">
          <span className="py-[6px] px-[7px] rounded-lg border-[2px] border-gray-200 shadow-sm">
            {/* <BookOpen size={22} color="#475467" /> */}
            <AlertTriangle size={22} color="#475467" />
          </span>
          <div>
            <p className="text-[1rem] font-semibold ">
              Unassign interview from students
            </p>
            {/* <p className="text-[.78rem] font-normal sub-text-color">
              Assign guides to help students prepare for interviews and
              assessments.
            </p> */}
          </div>
        </div>
      }
    >
      <div className="mt-5">
        <p className="text-[.9rem] font-normal text-[#344054] mb-2">
          Are you sure you want to unassign Interview from the selected student(s)?
        </p>
      </div>
      <div className="flex items-center gap-3 mt-6">
        <button
          className="btn-white px-3 py-2 rounded-lg sm:w-1/2 w-full"
          onClick={() => setUnAssignStudentFlag(false)}
        >
          Cancel
        </button>

        <button
          disabled={selectedUserIds?.length < 1}
          onClick={handleSubmit}
          className={` ${selectedUserIds?.length < 1 ? "btn-disabled" : "btn-orange"} px-3 py-2 rounded-lg sm:w-1/2 w-full`}
        >
          Unassign student(s)
        </button>
      </div>
    </Modal>
  );
}

export default UnassignStudentModal;
